<template lang="pug">
  div.objects-table
    e-table-inner(
      :visibleColumns="visibleColumns"
      :itemsEndpoint="getObjectsEndpoint"
      :showDeleteButton="false"
    )
</template>

<script>
  import {tko} from '../../../api/api-endpoints'

  export default {
    name: 'objects-table',
    props: {
      fields: {
        type: Object,
        default: function () {
          return {}
        }
      }
    },
    computed: {
      visibleColumns () {
        return {
          name: {label: 'Наименование объекта'},
          address: {label: 'Адрес объекта'},
          operator: {label: 'Оператор', path: 'name'},
          inn: {label: 'ИНН'},
          license_number: {label: 'Номер лицензии'},
          license_start_date : {label: 'Дата начала'},
          license_finish_date : {label: 'Дата конца'}
        }
      }
    },
    methods: {
      getObjectsEndpoint (ctx) {
        console.log('getObjectsEndpoint', this.fields, ctx)
        let route = {
          query: {
            'per-page': 10,
            'tech_id': this.fields.id
          }
        }
        if (ctx.paginateObj) {
          route.query = Object.assign(route.query, ctx.paginateObj)
        }
        if (ctx.currentSort) {
          route.query.sort = ctx.currentSort
        }
        return {
          url: this.fields.id ? tko.objects(route) : null,
          fields: this.visibleColumns
        }
      }
    }
  }
</script>
